/// We can only create 10 permits at a time because the BankID signing cannot fit more characters
export const maxPermitsBatchSize = 10;